module.exports = __webpack_public_path__ + "static/media/(V)_MG_6144_-_Joias_Contenporaneas.aee48c02.jpg";